'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$create = _interopDefault(require('babel-runtime/core-js/object/create'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var keyCodes = _interopDefault(require('../global/keycodes.js'));
var I18n = _interopDefault(require('../global/i18n.js'));
var A11y = _interopDefault(require('../global/a11y-helpers.js'));
var Config = _interopDefault(require('../global/config.js'));
var EventEmitter = _interopDefault(require('../helpers/event-emitter.js'));
var utils_js = require('../helpers/utils.js');
require('./jquery.preparetransition.js');

function anonymous(locals, escapeFn, include, rethrow
/*``*/) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
}var __line = 1
  , __lines = "<div class=\"modal-container\" id=\"ModalContainer\" aria-hidden=\"true\">\n  <div class=\"modal__header\">\n    <div class=\"page-width modal__controls\">\n      <button type=\"button\" class=\"modal__close\" id=\"CloseModal\">\n        <span class=\"icon\" id=\"CloseIcon\">\n          <span class=\"visuallyhidden\"><%= locals.closeLabel %></span>\n        </span>\n      </button>\n    </div>\n  </div>\n\n  <div class=\"modal page-width\" role=\"dialog\" tabindex=\"-1\" aria-labelledby=\"ModalTitle\"></div>\n</div>\n"
  , __filename = undefined;
try {
  var __output = [], __append = __output.push.bind(__output);
 __append("<div class=\"modal-container\" id=\"ModalContainer\" aria-hidden=\"true\">\n  <div class=\"modal__header\">\n    <div class=\"page-width modal__controls\">\n      <button type=\"button\" class=\"modal__close\" id=\"CloseModal\">\n        <span class=\"icon\" id=\"CloseIcon\">\n          <span class=\"visuallyhidden\">")
    ; __line = 6
    ; __append(escapeFn( locals.closeLabel ))
    ; __append("</span>\n        </span>\n      </button>\n    </div>\n  </div>\n\n  <div class=\"modal page-width\" role=\"dialog\" tabindex=\"-1\" aria-labelledby=\"ModalTitle\"></div>\n</div>\n")
    ; __line = 14;
  return __output.join("");
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}

/**
 * Modal window
 * @param {HTMLElement}  el Element triggering the modal, usually a button or anchor
 * @param {function}     template compiled ejs template for modal
 * @param {object}       [options] optional configuration object
 * @param {string}       [options.modalActiveSourceClass='js-modal-current-source'] Class added to trigger element while modal is active
 * @param {string}       [options.modalActiveBodyClass='js-modal-open'] class added to body while modal is open
 * @param {string}       [options.modalActiveContainerClass='js-is-active'] class added to modal container element while modal is open
 * @param {object}       [options.modalStyleModifierClasses={container: 'modal-container--lowlight', closeIcon: 'icon-modules-close-white'}] optional style modifer classes for container and close icon
 * @param {boolean}      [options.clickingOverlayClosesModal=true] whether clicking background of modal closes modal
 * @param {boolean}      [options.emptyOnClose=true] whether modal DOM is emptied when modal closed.
 * @param {boolean}      [options.preventEventDefault=true] whether to call preventDefault on the clicking event of the modal trigger
 * @param {function}     [options.afterModalRender=null] callback function after modal template is rendered, receives the rendered template wrapped in jQuery as param
 * @class Modal
 * @namespace ShopifyMarketing
 * @constructor
*/
function Modal(el, template, options) {
  EventEmitter.apply(this);

  var defaults = {
    modalActiveSourceClass: 'js-modal-current-source',
    modalActiveBodyClass: 'js-modal-open',
    modalActiveContainerClass: 'js-is-active',
    modalStyleModifierClasses: {
      container: 'modal-container--lowlight',
      closeIcon: 'icon-modules-close-white'
    },
    clickingOverlayClosesModal: true,
    emptyOnClose: true,
    preventEventDefault: true,
    afterModalRender: null
  };

  this.options = _Object$assign({}, defaults, options);

  this.$body = $(document.body);

  if (!$('#ModalContainer').length) {
    this.$body.prepend(anonymous({ closeLabel: I18n.t('modal.close') }));
  }

  this.$siteContainer = $('#SiteContainer');

  this.modalDom = {
    $container: $('.modal-container'),
    $modal: $('.modal'),
    $closeBtn: $('#CloseModal'),
    $closeIcon: $('#CloseIcon')
  };

  this.$modalSource = utils_js.isJquery(el) ? el : $(el);
  this.$modalTrigger = this.$modalSource;

  this._onClick = this._onClick.bind(this);
  this._onBackdropClick = this._onBackdropClick.bind(this);
  this._onKeyDown = this._onKeyDown.bind(this);
  this.close = this.close.bind(this);

  this.$modalSource.on({
    click: this._onClick,
    keydown: this._onKeyDown
  });

  // Needed since can't bind to top level elem as well as its children using .on().
  this.modalDom.$closeBtn.on('click', this.onCloseButtonClick.bind(this));

  if (this.options.clickingOverlayClosesModal) {
    this.modalDom.$container.on('click', this._onBackdropClick);
  }

  this.modalDom.$container.on('keydown', this._onKeyDown);

  this.template = template;
  this.currentIndex = -1;
  this.$activeSource = this.$modalSource.eq(0);
  this.active = false;
}

Modal.prototype = _Object$create(EventEmitter.prototype);

/**
 * Open modal window
 * @method  open
 * @param {Event} evt event object returned from click event handler
*/
Modal.prototype.open = function (evt) {
  this.scrollTopPosition = this.getScroll();

  this.render();

  // Add style modifier classes to icon and container
  this.modalDom.$closeIcon.addClass(this.options.modalStyleModifierClasses.closeIcon);
  this.modalDom.$container.addClass(this.options.modalStyleModifierClasses.container);

  Config.set('activeModal', this);

  this.active = true;
  if (evt) {
    this.$modalTrigger = $(evt.currentTarget);
  }

  this.modalDom.$container.prepareTransition().addClass(this.options.modalActiveContainerClass);
  this.$body.addClass(this.options.modalActiveBodyClass);

  this.$siteContainer.attr('aria-hidden', true);
  this.modalDom.$container.attr('aria-hidden', false);

  this.modalDom.$modal.focus();
  this.modalDom.$container[0].scrollTop = 0;

  A11y.prototype.trapFocus(this.modalDom.$container, 'modal_focus');

  this.emit('opened', evt);
};

/**
* Close modal window
* @method close
* @param {function} [callback] function called after modal is closed
*/
Modal.prototype.close = function (callback) {
  var _this = this;

  this.active = false;

  this.modalDom.$container.one('transitionended', function () {
    if (_this.options.emptyOnClose) {
      _this.empty();
    }

    if ($.isFunction(callback)) {
      callback();
    }

    _this.emit('closed');
  });

  this.modalDom.$container.prepareTransition().removeClass(this.options.modalActiveContainerClass);

  this.$body.removeClass(this.options.modalActiveBodyClass);

  this.$modalSource.removeClass(this.options.modalActiveSourceClass);

  // Remove modifier classes from icon and container
  this.modalDom.$closeIcon.removeClass(this.options.modalStyleModifierClasses.closeIcon);
  this.modalDom.$container.removeClass(this.options.modalStyleModifierClasses.container);

  this.$siteContainer.attr('aria-hidden', false);
  this.modalDom.$container.attr('aria-hidden', true);

  // turn of the focus listener
  A11y.prototype.removeTrapFocus(this.modalDom.$container, 'modal_focus');

  if (this.$modalTrigger && this.$modalTrigger.length) {
    this.$modalTrigger.focus();
  } else {
    this.$modalSource.focus();
  }

  Config.set('activeModal', null);

  this.currentIndex = -1;

  this.setScroll(this.scrollTopPosition);
};

/**
 * Return the current scroll position from the top in pixels.
 *
 * @method getScroll
 * @return {integer}
 */
Modal.prototype.getScroll = function () {
  return $(window).scrollTop();
};

/**
 * Set the current scroll top position to the given value
 *
 * @method setScroll
 * @param {integer} value  In pixels
 */
Modal.prototype.setScroll = function (value) {
  $(window).scrollTop(value);
};

/**
 * Removes the contents of the modal from the DOM.
 *
 * @method empty
 */
Modal.prototype.empty = function () {
  this.modalDom.$modal.empty();
};

/**
 * Renders the modal content, invoking the template with the data attributes
 * from the modal trigger element.
 *
 * Optionally invoke `afterModalRender` function if it was passed.
 *
 * @method render
 */
Modal.prototype.render = function () {
  var modalHTML = this.template(this.$activeSource.data());
  this.modalDom.$modal.html(modalHTML);
  this.picturefill();

  if (this.options.afterModalRender) {
    this.options.afterModalRender(this.modalDom.$modal);
  }
};

/**
 * If picturefill polyfill is available, run it over the modal contents.
 *
 * @method picturefill
 */
Modal.prototype.picturefill = function () {
  var $pictures = this.modalDom.$modal.find('picture > img');

  if ($pictures.length && window.picturefill) {
    window.picturefill({
      elements: $pictures
    });
  }
};

Modal.prototype._onClick = function (evt) {
  if (this.options.preventEventDefault) {
    evt.preventDefault();
  }

  this.open(evt);
};

Modal.prototype._onKeyDown = function (evt) {
  if (this.active) {
    switch (evt.keyCode) {
      case keyCodes.ESCAPE:
        this.close();
        break;
      default:
        break;
    }
  }
};

Modal.prototype._onBackdropClick = function (evt) {
  if (evt.target === evt.delegateTarget && this.active) {
    this.close();
  }
};

Modal.prototype.onCloseButtonClick = function () {
  if (this.active) {
    this.close();
  }
};

module.exports = Modal;
